function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.507 13.885a1.197 1.197 0 01-.419-.342L1.773 6.8a1.28 1.28 0 01-.273-.804c0-.095.01-.19.03-.283.02-.094.052-.188.097-.282L2.92 2.698c.105-.212.25-.382.436-.508.186-.127.394-.19.626-.19h8.04c.229 0 .436.063.622.19a1.3 1.3 0 01.436.508l1.296 2.733a1.308 1.308 0 01.124.565 1.28 1.28 0 01-.273.804l-5.312 6.743a1.225 1.225 0 01-.422.342 1.124 1.124 0 01-.986 0zm-1.5-8.197h3.986L8.74 3.032H7.263L6.007 5.688zm1.507 6.794V6.72H2.99l4.524 5.762zm.975 0l4.524-5.762H8.49v5.762zm2.59-6.794h2.313L12.198 3.16a.22.22 0 00-.194-.128H9.823l1.257 2.656zm-8.47 0h2.315l1.253-2.656H3.999a.208.208 0 00-.117.036.2.2 0 00-.077.092L2.608 5.688z",
  fill: "#2D2D2D"
});
function SvgDiamante(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Diamante.svg";
export { SvgDiamante as ReactComponent };